import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AngularAppLogger } from '../../angular-app-logger';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private appLogger: AngularAppLogger) {}

  intercept(request: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const context = {
          context: `HTTP Interceptor caught error`,
          url: request.url,
          component: "HttpErrorInterceptor"
        };

        const formattedError = this.appLogger.formatMessage(error);
        this.appLogger.logError(formattedError, context);
        console.error('[HTTP Error]', formattedError, context);

        return throwError(() => error);
      })
    );
  }
}
